import { ReactElement } from 'react';
import ScrollProvider from './components/_misc/ScrollProvider';
import { PageProvider } from './context/page/PageProvider';
import { PageRevisionProvider } from './context/page-revision/PageRevisionProvider';
import { StoreThemeProvider } from './context/store-theme/StoreThemeProvider';
import { ThemeProvider } from './context/theme/ThemeProvider';

const MINUMUM_DELAY = 0;

export const ProviderWrapper = ({ children, includePageProviders, includeStoreProvider }: { children: ReactElement, includePageProviders?: boolean, includeStoreProvider?: boolean }) => {
  const combinedChildren = (
    <>
      {children}
      <ScrollProvider />
    </>
  );
  if (includePageProviders) {
    return (
      <PageProvider>
        <PageRevisionProvider>
          {combinedChildren}
        </PageRevisionProvider>
      </PageProvider>
    );
  }
  else if (includeStoreProvider) {
    return (
      <StoreThemeProvider minimumDelay={MINUMUM_DELAY}>
        {combinedChildren}
      </StoreThemeProvider>
    );
  }
  else {
    return (
      <ThemeProvider minimumDelay={MINUMUM_DELAY}>
        {combinedChildren}
      </ThemeProvider>
    );
  }
};
